import type { ReactNode } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';

import { PracticeSettingsHeading } from './PracticeSettingsHeading';

/** Both catalogs share the same gutters, header spacing, and bounded table area. */
export function PracticeSettingsCatalogLayout({
  id,
  embedded,
  title,
  subtitle,
  backLabel,
  onBack,
  actions,
  children,
}: {
  id: string;
  embedded: boolean;
  title: string;
  subtitle: string;
  backLabel: string;
  onBack: () => void;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Box
      id={id}
      sx={{
        height: '100%',
        minHeight: 0,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'hidden',
        overflowY: { xs: 'auto', md: 'hidden' },
      }}
    >
      <Box sx={{ px: embedded ? 0 : 3, pt: embedded ? 0 : 2, flexShrink: 0 }}>
        {!embedded && (
          <Button size="small" startIcon={<ArrowBackIcon />} onClick={onBack} sx={{ ml: -1 }}>
            {backLabel}
          </Button>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            mb: 3,
            '& > div:first-of-type': { mb: 0 },
          }}
        >
          <PracticeSettingsHeading title={title} subtitle={subtitle} />
          {actions}
        </Box>
      </Box>
      <Box
        sx={{
          flex: '1 1 auto',
          // Wrapped filters plus the settings header can fill a short phone viewport.
          // Keep a usable table below them and let the catalog scroll to its controls.
          minHeight: { xs: 420, md: 0 },
          px: embedded ? 0 : 3,
          pb: embedded ? 0 : 2.5,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
